import React, { type InputHTMLAttributes, useCallback, useEffect, useMemo, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '@pkg/hooks';

import { addNotification } from '@app/store/actions/notification';

import './_Input.scss';

interface YatInputProps extends InputHTMLAttributes<HTMLInputElement> {
    classes?: string;
    autoFocus?: boolean;
}

export const YatInput = ({ autoFocus, classes, ...props }: YatInputProps) => {
    const { t } = useTranslation(['account', 'common']);
    const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

    const dispatch = useAppDispatch();

    const classNames = useMemo(() => {
        let classNames = 'yat-input';
        if (classes) classNames += ` ${classes}`;

        return classNames;
    }, [classes]);

    const showCustomAlert = useCallback(
        (form) => {
            form.preventDefault();
            dispatch(
                addNotification({
                    message: t('valid_email_request'),
                    title: t('common:error_invalid_email'),
                    severity: 'alert',
                }),
            );
        },
        [dispatch, t],
    );

    useEffect(() => {
        if (autoFocus && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus, inputRef]);

    return (
        <input
            name="yat-input"
            className={classNames}
            {...props}
            onInvalid={(form) => showCustomAlert(form)}
            ref={inputRef}
        />
    );
};
